import { render, staticRenderFns } from "./One_contacts.vue?vue&type=template&id=4c2507ae&"
import script from "./One_contacts.vue?vue&type=script&lang=js&"
export * from "./One_contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports